module.exports = __webpack_public_path__ + "img/piggy-bank.4a7a126.svg";